import { Grid } from '@material-ui/core';
import React from 'react';
import localStorage from 'utils/localStorage';
import { ReactComponent as Participant } from 'assets/images/participant.svg';
import { ReactComponent as Question } from 'assets/images/question.svg';
import PropTypes from 'prop-types';
import styles from '../styles.module.scss';

const QuizInfo = ({
  number,
  name,
  organizer,
  team,
  channel,
  participants,
  questions,
  time,
  date,
  onSelect,
  id
}) => {
  const showHash = localStorage.getPlatform() === 'slack';
  return (
    <Grid
      container
      className={styles.listItem}
      alignItems='center'
      key={id}
      onClick={() => onSelect(id)}
    >
      <Grid className={styles.listItemCell} item md={1}>
        {number}
      </Grid>
      <Grid className={styles.listItemCell} item md={6} lg={6}>
        <div style={{ lineHeight: '2.75rem' }}>
          <div className={styles.name}>{name}</div>
          <div className={styles.organized}>
            Organized by <span>{organizer}</span>{' '}
            {team && (
              <>
                for <span>{team}</span>
              </>
            )}{' '}
            on {showHash && '#'}
            <span>{channel}</span>
          </div>
        </div>
      </Grid>
      <Grid className={styles.listItemCell} item md={5}>
        <div className={styles.statsWrapper}>
          <div className={styles.stat}>
            <Participant />
            {participants}
          </div>
          <div className={styles.text}>Participants</div>
        </div>
        <div className={styles.statsWrapper}>
          <div className={styles.stat}>
            <Question />
            {questions}
          </div>
          <div className={styles.text}>Questions</div>
        </div>
        <div className={styles.statsWrapper}>
          <div className={styles.time}>{time}</div>
          <div className={styles.date}>{date}</div>
        </div>
      </Grid>
    </Grid>
  );
};

QuizInfo.propTypes = {
  number: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  organizer: PropTypes.string.isRequired,
  team: PropTypes.string,
  channel: PropTypes.string,
  participants: PropTypes.number.isRequired,
  questions: PropTypes.number.isRequired,
  time: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired
};

QuizInfo.defaultProps = {
  team: '',
  channel: ''
};

export default QuizInfo;
